<template>
    <div>
        <v-row class="mb-0 mt-0">
            <v-col cols="auto">
                <v-chip color="grey lighten-3" label>Wat</v-chip>
            </v-col>
            <v-col>
                <eod-autocomplete :value="value.source"  :items="sources"
                    item-value="table"
                    @input="val => updateProperty('source', val)"></eod-autocomplete>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mb-0 mt-0">
            <v-col cols="auto">
                <v-chip color="grey lighten-3" label>Velden</v-chip>
            </v-col>
            <v-col v-if="value.source == null">
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" color="grey"
                            icon><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="field in fields"
                            :key="field.key" @click="addCustomField(field)">
                            <v-list-item-title>{{ field.text }} ({{ field.key }})</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <v-col v-else>
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" color="grey"
                            icon><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="field in getSourceConfig().fields.filter(item => !(value.fields && value.fields.map(item => item.key).includes(item.key) && !item.type.aggregations))"
                            :key="field.key" @click="addField(field)">
                            <v-list-item-title>{{ field.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <draggable v-model="value.fields" group="form" handle=".handle">
            <v-row  class="mb-0 mt-0" v-for="(field, fieldIndex) in getFields()" :key="fieldIndex">
                <v-col cols="auto">
                    <v-icon class="handle cursor-move">mdi-drag</v-icon>
                </v-col>
                <template v-if="field.field.isCustom">
                    <v-col>
                        <v-row>
                            <v-col cols="auto">
                                <eod-text-field label="veldnaam" :value="field.field.key" @input="val => updateField(fieldIndex, 'key', val)"></eod-text-field>
                            </v-col>
                            <v-col cols="auto">
                                <eod-text-field label="label" :value="field.field.label" @input="val => updateField(fieldIndex, 'label', val)"></eod-text-field>
                            </v-col>
                            <v-col cols="auto">
                                <eod-autocomplete
                                    :value="field.field.originalKey"
                                    label="Eigenschappen overnemen van"
                                    item-value="key"
                                    :item-text="item => item.text+' ('+item.key+')'"
                                    :items="fields"
                                    @input="val => updateField(fieldIndex, 'originalKey', val)"></eod-autocomplete>
                            </v-col>
                        </v-row>
                    </v-col>
                    
                </template>
                <template v-else>
                <v-col cols="auto">
                    <v-chip color="primary">{{ field.field.text }}</v-chip>
                </v-col>
                <v-col>
                        <eod-autocomplete
                            v-if="field.field.type.aggregations && value.source != null"
                            :value="value.fields[fieldIndex].aggregation"
                            label="Bewerking"
                            item-value="key"
                            :items="field.field.type.aggregations"
                            @input="val => updateField(fieldIndex, 'aggregation', val)"></eod-autocomplete>
                    </v-col>
                </template>
                    <v-col cols="auto">
                        <v-btn @click="deleteField(fieldIndex)" icon color="error"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                    </v-col>
            </v-row>
        </draggable>
        <v-divider></v-divider>
        <div v-if="value.source != null">
        <eod-query-fixed-filters :value="value.filters" @input="val => updateProperty('filters', val)" :fields="getSourceConfig().fields"></eod-query-fixed-filters>
        <v-divider></v-divider>
    </div>
        <div v-else>
            <v-row class="mb-0 mt-0">
                <v-col cols="auto">
                    <v-chip color="grey lighten-3" label>Meetwaardetype</v-chip>
                </v-col>
                <v-col>
                    <eod-object-autocomplete endpoint="measurementTypes" clearable no-autoselect :value="getRawMeasurementTypeId()" @input="setRawMeasurementTypeId"></eod-object-autocomplete>
                    <div class="text-caption grey--text mt-1">Bepaalt de kleur per asset, de eenheid en de naam van de reeksen in grafieken. Filtert de query niet, tenzij ze [[dynamic_filter:measurement_type_id]] bevat.</div>
                </v-col>
            </v-row>
            <v-divider></v-divider>
        </div>

        <v-row class="mb-0 mt-0">
                                            <v-col cols="auto">
                                                <v-chip color="grey lighten-3" label>Dynamische filters</v-chip>
                                            </v-col>
                                            <v-col>
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" v-on="on" color="grey"
                                                            icon><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item
                                                            v-for="field in (value.source?getSourceConfig().fields:fields)"
                                                            :key="field.key" @click="addDynamicFilter(field)">
                                                            <v-list-item-title>{{ field.text }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </v-col>
                                        </v-row>
                                        <v-row class="mb-0 mt-0" v-for="(filter, index) in getDynamicFields()"
                                            :key="'dynamic_filter_' + index">

                                            <v-col class="d-flex align-items-center" cols="auto">
                                                <v-chip color="primary">{{
                                                    filter.field.text }}</v-chip>
                                            </v-col>
                                            <v-col class="d-flex align-items-center" cols="auto">
                                                <v-text-field outlined hide-details dense
                                                    v-model="value.dynamic_filters[index].value"
                                                    label="label"></v-text-field>
                                            </v-col>
                                            <v-col class="d-flex align-items-center" cols="auto">
                                                <v-btn @click="removeDynamicFilter(index)" icon
                                                    color="error"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <div v-if="value.source">
                                            <v-row class="mb-0 mt-0">
                                                <v-col cols="auto">
                                                    <v-chip color="grey lighten-3" label>Groeperen</v-chip>
                                                </v-col>
                                                <v-col>
                                                    <v-menu offset-y>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn v-bind="attrs" v-on="on" color="grey"
                                                                icon><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
                                                        </template>
                                                        <v-list>
                                                            <v-list-item
                                                                v-for="field in getSourceConfig().fields.filter(item => !(value.group && value.group.includes(item.key)))"
                                                                :key="field.key" @click="addGrouping(field)">
                                                                <v-list-item-title>{{ field.text }}</v-list-item-title>
                                                            </v-list-item>
                                                        </v-list>
                                                    </v-menu>
                                                </v-col>
                                                <v-col v-if="value.group" cols="12">
                                                    <v-chip color="primary" class="mr-2 mb-2" v-for="(field, groupIndex) in getGroups()" @click:close="deleteGroup(groupIndex)" close :key="groupIndex">{{ field.text }}</v-chip>
                                                </v-col>
                                            </v-row>
                                        <template v-if="value.group && value.group.includes('time')">
                                            <v-divider></v-divider>
                                            <v-row class="mb-0 mt-0">
                                                <v-col cols="auto">
                                                    <v-chip color="grey lighten-3" label>Tijdsselectie</v-chip>
                                                </v-col>
                                                <v-col>
                                                    <v-row>
                                                        <v-col>
                                                            <v-checkbox class="mt-0" @change="val => updateProperty('ignoreTimeFilter', val)" :input-value="value.ignoreTimeFilter" label="Negeer de tijdsselectie"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </div>
                                    <div v-else>
                                        <v-row class="mb-0 mt-0">
            <v-col cols="auto">
                <v-chip color="grey lighten-3" label>Query</v-chip>
            </v-col>
            <v-col>
               
                
                                                <eod-textarea class="mb-4" :value="value.raw" @input="val => updateProperty('raw', val)" label="query"></eod-textarea>
                                                <v-tooltip right  v-for="tag in rawQueryTags" :key="tag.key">
                    <template v-slot:activator="{on, attrs}">
                        <v-chip class="mb-1 mr-1" v-on="on" v-bind="attrs">{{ tag.value }}</v-chip>
                    </template>
                    <div v-html="tag.text"></div>
                </v-tooltip>
                                            </v-col>
        </v-row>
                                    </div>
    </div>
</template>

<script>
import eodQueryFixedFilters from './eod-query-fixed-filters.vue';
import {QUERY_SOURCES, QUERY_FIELDS, QUERY_FIELD_TYPES, QUERY_REPLACE_TAGS, QUERY_FIELD_VISUALIZATIONS} from './../plugins/queryeditor/config.js';
import draggable from 'vuedraggable';
export default {
    name: 'eod-query-builder',
    components:{
        eodQueryFixedFilters,
        draggable
    },
    props: {
        value: Object
    },
    data: () => ({
        sources: Object.values(QUERY_SOURCES),
        fieldTypes: Object.values(QUERY_FIELD_TYPES),
        fields: Object.values(QUERY_FIELDS),
        views: Object.values(QUERY_FIELD_VISUALIZATIONS),
        rawQueryTags: Object.values(QUERY_REPLACE_TAGS),
    }),
    created(){
        if(this.$eod.getUser().isRoot()){
            this.sources.push({
                text: 'Ruwe query',
                table: null,
            });
        }
    },
    methods: {
        addCustomField(field){
            const val = this.value;
            if (!val.fields) {
                val.fields = [];
            }

            val.fields.push({
                key: field.key,
                originalKey: field.key,
                isCustom: true,
            });

            this.$emit('input', val);
            this.refreshView();
        },
        updateProperty(propertyName, newVal){
            const val = this.value;
            val[propertyName] = newVal;

            this.$emit('input', val);
        },
        // A raw query has no source to filter on, so the measurement_type_id entry in filters only links
        // the query to a measurement type (asset colors, unit and label in graphs, see resolveQueryMeasurementType)
        getRawMeasurementTypeId(){
            if(!this.value.filters){
                return null;
            }

            const filter = this.value.filters.find(item => item.field && item.field.key == 'measurement_type_id');
            return filter?filter.value:null;
        },
        setRawMeasurementTypeId(measurementTypeId){
            const val = this.value;
            const filters = (val.filters || []).filter(item => !(item.field && item.field.key == 'measurement_type_id'));

            if(measurementTypeId){
                filters.push({
                    field: {
                        key: 'measurement_type_id'
                    },
                    operator: '=',
                    value: measurementTypeId
                });
            }

            val.filters = filters;
            this.$emit('input', val);
            this.refreshView();
        },
        getSourceConfig(){
            return QUERY_SOURCES[this.value.source];
        },
        updateField(index, fieldName, value){
            const val = this.value;
            val.fields[index][fieldName] = value;
            this.$emit('input', val);
        },
        getFields(){
            const fields = [];
            if(this.value && this.value.fields){
                for (let i = 0; i < this.value.fields.length; i++) {
                    const field = this.value.fields[i];
                    if(field.isCustom){
                        fields.push({
                            field: field,
                            aggregation: field.aggregation,
                        });
                    } else if(QUERY_FIELDS[field.key]){
                        fields.push({
                            field: QUERY_FIELDS[field.key],
                            aggregation: field.aggregation
                        });
                    }
                    
                }
            }
            return fields;
        },
        getGroups(){
            const fields = [];
            if(this.value && this.value.group){
                for (let i = 0; i < this.value.group.length; i++) {
                    const fieldKey = this.value.group[i];
                    if(QUERY_FIELDS[fieldKey]){
                        fields.push(QUERY_FIELDS[fieldKey]);
                    }
                }
            }

            return fields;
        },
        deleteGroup(groupIndex){
            const val = this.value;
            val.group.splice(groupIndex, 1);
            this.$emit('input', val);
            this.refreshView();
        },
        addField(field){
            const val = this.value;
            if (!val.fields) {
                val.fields = [];
            }

            val.fields.push({
                key: field.key,
                aggregation:null,
            });

            if(val.group && !val.group.includes(field.key)){
                val.group.push(field.key);
            }

            this.$emit('input', val);
            this.refreshView();
        },
        addFieldType(field){
            const val = this.value;
            if (!val.fields) {
                val.fields = [];
            }

            val.fields.push({
                type: field.key,
                key: null,
                aggregation:null,
            });

            this.$emit('input', val);
            this.refreshView();
        },
        deleteField(fieldIndex){
            const val = this.value;
            val.fields.splice(fieldIndex, 1);
            this.$emit('input', val);
            this.refreshView();
        },
        addGrouping(field){
            const val = this.value;
            if (!val.group || !val.group[0]) {
                if(val.fields){
                    val.group = val.fields.filter(item => !item.aggregation).map(item => item.key);
                } else {
                    val.group = [];
                }
            }

            if(!val.group.includes(field.key)){
                val.group.push(field.key);
            }

            this.$emit('input', val);
            this.refreshView();
        },
        getDynamicFields(){
            const filters = [];
            if(this.value && this.value.dynamic_filters){
                for (let i = 0; i < this.value.dynamic_filters.length; i++) {
                    const filter = this.value.dynamic_filters[i];
                    filters.push({
                        field: QUERY_FIELDS[filter.field.key],
                        value: filter.value
                    });
                }
            }

            return filters;
        },
        addDynamicFilter(filter) {
            const val = this.value;
            if (!val.dynamic_filters) {
                val.dynamic_filters = [];
            }

            val.dynamic_filters.push({
                field: {
                    endpoint: filter.endpoint,
                    key: filter.key,
                },
                value: filter.text
            });

            this.$emit('input', val);
            this.refreshView();
        },
        removeDynamicFilter(index) {
            const val = this.value;
            val.dynamic_filters.splice(index, 1);
            this.$emit('input', val);
            this.refreshView();
        },
        refreshView(){
            this.$nextTick(() => {
                this.$forceUpdate();
            })
        }
    }
}
</script>